import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchAutoPayNotify } from "../../../../shared/hooks/useFetchPayment";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import DwLogutil from "../../Utils/DwLogutil";

type autopayNotifyInitialStateType = {
  autopayNotify: any;
  loading: boolean;
  error: any;
};

const initialState: autopayNotifyInitialStateType = {
  autopayNotify: null,
  loading: false,
  error: null,
};

export const getAutopayNotify = createAsyncThunk(
  "autopay/notify",
  async (billingAccountNumber: string) => {
    try {
      if (process.env.REACT_APP_ENABLE_AUTOPAY_NOTIFY !== "true") {
        return;
      }
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      let url:string = API_URLS['autopayNotifyUrl'] ?? ""
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.autopay_notify_API_attempted });
      const response = await fetchAutoPayNotify(
        {
          [url]: billingAccountNumber,
        },
        headers,
      );
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.autopay_notify_API_success });
      return response.data
    } catch (error) {
      DwLogutil({ 
         stepName: EC_DW_LOGGING_STEPS.autopay_notify_API_failed,
         error: (error as any)?.response?.data?.message || (error as any)?.message || "Autopay notify API failed",
       });
      throw error;
    }
  }
);

const autopayNotifySlice = createSlice({
  name: "autopay/notify",
  initialState,
  reducers: {
    clearAutopayNotifySlice: (state) => {
      return initialState;
    },
    autopayNotifySliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getAutopayNotify.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAutopayNotify.fulfilled, (state, action) => {
      state.autopayNotify = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getAutopayNotify.rejected, (state, action) => {
      state.autopayNotify = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const { clearAutopayNotifySlice, autopayNotifySliceSetInitialState } =
  autopayNotifySlice.actions;
export default autopayNotifySlice.reducer;
